export const bannerTranslate = {
    es : {
        title: "La membresía para el viajero inteligente.",
        button: 'Ir a mi membresía',
        buttonLogin: 'Ir al Dashboard',
        plus: {
            title: 'La membresía para el viajero inteligente. Tarifas bajas y equipaje extra, ¡así es ser Viva Fan!',
            benefits: {
                title: 'Disfruta de tarifas aún más bajas y beneficios exclusivos',
                tag: '  Viva Fan se renueva'
            } 

        }
    },
    eng : {
        title: "A membership for the savvy traveler.",
        button: "Go to my membership",
        buttonLogin : 'Go to Dashboard',
        plus: {
            title: 'La membresía para el viajero inteligente. Tarifas bajas y equipaje extra, ¡así es ser Viva Fan!',
            benefits: {
                title: 'Disfruta de tarifas aún más bajas y beneficios exclusivos ',
                tag: 'Viva Fan se renueva'
            } 
        }
        }
    }